export const uploadEn = {
    UPLOAD: 'Upload',
    UPLOAD_DOCS: 'Upload Documents',
    UPLOAD_FILES: 'Upload Files',
    SUBMIT_FILES: 'Submit Files',
    ALL_TYPE_ALLOWED: 'PDF, PNG and JPG',
    INVOICE_TYPES_ALLOWED: 'PDF, images and Excel',
    DRAG_AND_DROP: 'Drag and Drop files or click Upload',
    UPLOAD_FILE_EXTENSIONS: 'PDF, JPEG or PNG',
    UPLOADING: 'Uploading',
    COMPLETED: 'Completed',
    ERROR_UPLOADING_FILE : 'Error uploading file',
    FILE_ALREADY_EXISTS: 'File already exists',
    JOB_SUBMIT_ERROR: "Couldn't process documents. Please try again later",
    INVOICE_DRAFT_ERROR: "Couldn't create draft",
    FILES_STILL_UPLOADING: 'Some files are still uploading. Wait until they are finished',
    SUBMIT_DOCUMENTS : 'Submit Documents',
    SCAN_DOCUMENTS : 'Scan Documents'
  }
  
  export const uploadEs: typeof uploadEn = {
    UPLOAD: 'Subida',
    UPLOAD_DOCS: 'Subir Documentos',
    UPLOAD_FILES: 'Subir Archivos',
    SUBMIT_FILES: 'Enviar Archivos',
    ALL_TYPE_ALLOWED: 'PDF, PNG y JPG',
    INVOICE_TYPES_ALLOWED: 'PDF, imágenes y Excel',
    DRAG_AND_DROP: 'Arrastra y suelta archivos, o presiona Subir',
    UPLOAD_FILE_EXTENSIONS: 'PDF, JPEG o PNG',
    UPLOADING: 'Subiendo',
    COMPLETED: 'Listo',
    ERROR_UPLOADING_FILE : 'Error subiendo archivo',
    FILE_ALREADY_EXISTS: 'El archivo ya existe',
    JOB_SUBMIT_ERROR: "Error procesando documentos. Por favor intente de nuevo mas tarde",
    INVOICE_DRAFT_ERROR: "No se pudo crear borrador",
    FILES_STILL_UPLOADING: 'Algunos archivos aún están subiendose. Espere por favor a que terminen',
    SUBMIT_DOCUMENTS : 'Enviar Documentos',
    SCAN_DOCUMENTS : 'Escanear Documentos'
  }
  